'use client'

import { useSearchStore } from '@stores/search.store'

import { useEffect } from 'react'

import type { JobSearch } from '@types'

type UpdateSearchProps = {
  data: JobSearch
}

export default function UpdateSearch({ data }: UpdateSearchProps): JSX.Element {
  const setSearch = useSearchStore((state) => state.setSearch)
  const setNextSearch = useSearchStore((state) => state.setNextSearch)

  useEffect(() => {
    setSearch(data)
    setNextSearch(data)
  }, [setSearch, data, setNextSearch])
  return <></>
}
